<ng-container *ngIf="layout === 'vertical'">
  <app-header-vertical></app-header-vertical>
</ng-container>
